import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function Card({ children, className = '', ...props }: CardProps) {
  return (
    <div className={['border border-[#ddd] bg-white', className].join(' ')} {...props}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '', ...props }: CardProps) {
  return (
    <div className={['border-b border-[#ddd] bg-[#fafafa] px-5 py-3', className].join(' ')} {...props}>
      {children}
    </div>
  );
}

export function CardContent({ children, className = '', ...props }: CardProps) {
  return (
    <div className={['px-5 py-4', className].join(' ')} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className = '', ...props }: CardProps) {
  return (
    <div className={['border-t border-[#ddd] bg-[#fafafa] px-5 py-3', className].join(' ')} {...props}>
      {children}
    </div>
  );
}
